export default function getValueOrUndefiend<T>(func: () => T): T | undefined {
	try {
		return func()
	} catch (error) {
		return undefined
	}
}
